import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

function Icon(props: Props) {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 768 768" {...props}>
      <path
        fill="currentColor"
        d="M767.875 63.98l-63.979-63.98-320.021 320.021-319.77-319.77-63.98 63.979 319.77 319.771-319.77 319.77 63.98 63.979 319.77-319.77 320.021 320.021 63.98-63.98-320.020-320.021 320.020-320.021z"
      ></path>
    </svg>
  );
}

export default Icon;
